// Firebase Web SDK — used ONLY for end-user auth on the companion dashboard.
//
// The mobile app authenticates with Firebase email/password; existing users sign in
// here with the same credentials. We reuse the project's existing config (project
// `sphyn-dev`); env vars override per-environment. For email/password,
// apiKey + authDomain + projectId are all the SDK needs — appId is optional.
//
// NOTE: a Firebase web apiKey is not a secret — it identifies the project, it does not
// grant access. Backend access is still gated by verifying the Firebase ID token.
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { envVar } from './lib/runtimeEnv';

export const firebaseConfig = {
  apiKey: envVar('REACT_APP_FIREBASE_API_KEY', 'AIzaSyAj88HVjMavkJgqmhFtee8gUfEeKm7RRBo'),
  authDomain: envVar('REACT_APP_FIREBASE_AUTH_DOMAIN', 'sphyn-dev.firebaseapp.com'),
  projectId: envVar('REACT_APP_FIREBASE_PROJECT_ID', 'sphyn-dev'),
  storageBucket: envVar('REACT_APP_FIREBASE_STORAGE_BUCKET', 'sphyn-dev.firebasestorage.app'),
  messagingSenderId: envVar('REACT_APP_FIREBASE_SENDER_ID', '423369016606'),
  appId: envVar('REACT_APP_FIREBASE_APP_ID', '1:423369016606:web:31d168c12353fcf345f50f'),
};

// VAPID public key for Web Push (Firebase Console → Cloud Messaging → Web configuration). Without
// it the SDK can't mint a web token; messaging.js no-ops cleanly so the rest of the app is fine.
export const VAPID_KEY = envVar('REACT_APP_FIREBASE_VAPID_KEY', '');

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// TEST-4 e2e: point auth at the local Firebase Auth emulator when the build was started with
// REACT_APP_AUTH_EMULATOR_HOST (see e2e/). Build-time env only — never set in real deploys, so
// production bundles contain the false branch and never touch the emulator path.
const AUTH_EMULATOR_HOST = envVar('REACT_APP_AUTH_EMULATOR_HOST', '');
if (AUTH_EMULATOR_HOST) {
  connectAuthEmulator(auth, `http://${AUTH_EMULATOR_HOST}`, { disableWarnings: true });
}

export default app;

